// src/pages/Admin/Dashboard/tabs/customers/index.jsx

import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

import CustomDataGrid from "../../../../../components/common/CustomDataGrid";
import { customerColumns } from "../../../../../constants/columns/customerColumns";

import { adminApi } from "../../../../../services/index";

export default function Customer() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchUsers = async () => {
    try {
      // const res = await getUsers();
      const res = await adminApi.getUsers();
      setUsers(res.data);
    } catch {
      setError("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  if (error) return <p>{error}</p>;
  console.log('Users', users);
  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h2>All Customers</h2>
        {/* <Link to='/admin-dashboard/create-customer'><button className="btn btn-primary" style={{height:"50px",width:'150px'}}> + Create Account</button></Link> */}
        <Link to='/admin-dashboard/customers/create'><button className="btn btn-primary" style={{height:"50px",width:'150px'}}> + Create Account</button></Link> 
      </div>
      <CustomDataGrid
        rows={users}
        columns={customerColumns}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}



